import React from "react";
import Classnames from "classnames";
import { Button, Spinner } from "@blueprintjs/core";
import ReactFullscreen from "react-full-screen";
import FadeIn from 'react-fade-in'

import Participant from "../../../services/Participant";

class ResourceViewer extends React.Component {
  render() {
    const { session} = this.props;
    const { metadata } = session;
    const { type } = metadata;

    if (type === "PILOTED" /* Use constant here */)
      return <PilotedLayout {...this.props} />;
      return <AutonomousLayout {...this.props} />;
  }
}

class PilotedLayout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fullscreen: this.props.fullscreen || false,
      imageLoading: true
    };
  }

  render() {
    const { fullscreen, imageLoading } = this.state;
    const { sessionInstance, session } = this.props;
    const { currentSequenceResource, currentSequence } = sessionInstance;
    const { metadata, data } = session;
    const { protocol } = metadata;
    const { sequences = [] } = data;
    const { resources } = sequences[currentSequence];
    const currentRessource = resources[currentSequenceResource];

    return (
      <ReactFullscreen enabled={fullscreen}>
  <div
    className={Classnames({
      "sequence-resource-wrapper ": true,
      "protocolPC": protocol === "PC",
      fullscreen: fullscreen
    })}
  >
    <Button
      icon={fullscreen ? "minimize" : "fullscreen"}
      large={true}
      onClick={() => this.setState({ fullscreen: !fullscreen })}
      className="fullscreen-btn"
      minimal={true}
    />
    <div className="legend">
      {currentSequence + 1}
    </div>
    {imageLoading && (
      <div className="hover-loading">
        <Spinner className="margin-top-large" />
      </div>
    )}
    {protocol === "PC" ? (
      resources.map((r, index) => (
        <div key={index}>
          {r.type === "IMAGE" && (
            <img
              onLoad={() => this.setState({ imageLoading: false })}
              src={r.downloadURL}
              className="img-responsive"
              alt="Resource"
            />
          )}
          {r.type === "VIDEO" && (
            <video
              onLoadedData={() => this.setState({ imageLoading: false })}
              src={r.downloadURL}
              className="img-responsive"
              alt="Resource"
              controls={true}
              autoPlay
              loop
            />
          )}
          <span className="image-icon-piloted">{index === 0 ? "A" : "B"}</span>
        </div>
      ))
    ) : (
      <>
        {currentRessource.type === "IMAGE" && (
          <img
            onLoad={() => this.setState({ imageLoading: false })}
            src={currentRessource.downloadURL}
            className="img-responsive"
            alt="Resource"
          />
        )}
        {currentRessource.type === "VIDEO" && (
          <video
            onLoadedData={() => this.setState({ imageLoading: false })}
            src={currentRessource.downloadURL}
            className="img-responsive"
            alt="Resource"
            controls={true}
            autoPlay
            loop
          />
        )}
      </>
    )}
  </div>
</ReactFullscreen>
    );
  }
}

class AutonomousLayout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fullscreen: this.props.fullscreen || false,
      imageLoading: true,
      more: true
    };
  }

  handleSwitchResource = index => {
    const { onSwitchResource } = this.props;
    this.setState({ imageLoading: true });
    onSwitchResource(index);
  };

  handleNextResource = index => {
    const { onSwitchResource } = this.props;

    this.setState({ imageLoading: true, more: true });

    onSwitchResource(this.props.sessionInstance.currentSequenceResource + 1);
  };

  handlePreviousResource = index => {
    const { onSwitchResource } = this.props;

    this.setState({ imageLoading: true, more: false });

    onSwitchResource(this.props.sessionInstance.currentSequenceResource - 1);
  };

  render() {
    const { fullscreen, imageLoading } = this.state;
    const { sessionInstance, session, viewMode } = this.props;
    const { currentSequenceResource, currentSequence } = sessionInstance;
    const { data, metadata } = session;
    const { protocol } = metadata;
    const { sequences = [] } = data;
    const { resources } = sequences[currentSequence];
    const currentRessource = resources[currentSequenceResource];
    
    let fixedChannel = false;
    if (data.mcCriterias) {
      fixedChannel = data.mcCriterias.find(criteria => criteria.isFixed === true);
    }

    // use in the MC protocol to update opacity of image
    const votedFor = Participant.getVoteForSequence(
      sessionInstance.results,
      sequences[currentSequence].id,
      Participant.getParticipantIdBySessionId(session.id)
    );

    return (
      <div className={protocol === "PC" && viewMode === 'double' ? "col-xs-12 col-md-12" : "col-xs-12 col-md-9"}>
        <ReactFullscreen 
          enabled={fullscreen} 
          viewMode={viewMode}
        >
          <div
            className={Classnames({
              "sequence-resource-wrapper": true,
              fullscreen: fullscreen
            })}
          >
            <Button
              icon={fullscreen ? "minimize" : "fullscreen"}
              large={true}
              onClick={() => this.setState({ fullscreen: !fullscreen })}
              className="fullscreen-btn"
              minimal={true}
            />
            {protocol === 'CM' && (
              <FadeIn>
                {currentRessource &&
                  <img
                    onLoad={() => this.setState({ imageLoading: false })}
                    src={currentRessource.downloadURL}
                    className="img-responsive"
                    alt="Resource"
                  />
                }
              </FadeIn>
            )}
            {protocol === "PC" && viewMode === 'single' && (
              <div className="resource-switcher">
              <div
                className={Classnames({
                    resource: true,
                    active: currentSequenceResource === 0
                })}
                onClick={() => this.handleSwitchResource(0)}
              >
                A
              </div>
              <div
                className={Classnames({
                  resource: true,
                  active: currentSequenceResource === 1
                })}
                onClick={() => this.handleSwitchResource(1)}
              >
                B
            </div>
            </div>
            )}
            {((protocol === "PC" && viewMode === "single") || protocol === "MS")  && (
              <div>
                {imageLoading && (
                  <div className="hover-loading">
                    <Spinner className="margin-top-large" />
                  </div>
                )}
                {currentRessource.type === "IMAGE" && (
                  <img
                    onLoad={() => this.setState({ imageLoading: false })}
                    src={currentRessource.downloadURL}
                    className="img-responsive"
                    alt="Resource"
                  />
                )}
                {currentRessource.type === "VIDEO" && (
                  <video
                    onLoadedData={() => this.setState({ imageLoading: false })}
                    src={currentRessource.downloadURL}
                    className="img-responsive"
                    alt="Resource"
                    controls={true}
                    autoPlay
                    loop
                  />
                )}
              </div>
            )}
            {protocol === "PC" && viewMode === 'double' &&(
              <div className="resources-PC">
                {resources.map((resource, index) => (
                  <div key={index} className="image-with-icon pc-image-container">
                    {/* Affichage des images pour le protocole PC en double view*/}
                    {resource.type === "IMAGE" && (
                      <img
                        onLoad={() => this.setState({ imageLoading: false })}
                        src={resource.downloadURL}
                        className="img-responsive relative"
                        alt={`Resource ${index}`}
                      />
                    )}
                    {resource.type === "VIDEO" && (
                      <video
                        onLoadedData={() => this.setState({ imageLoading: false })}
                        src={resource.downloadURL}
                        className="img-responsive relative"
                        alt="Resource"
                        controls={true}
                        autoPlay
                        loop
                      />
                    )}
                    <span className="image-icon">{index === 0 ? "A" : "B"}</span>
                  </div>
                ))}
              </div>
            )}
            {protocol === "MC" && votedFor != null && (
              <div className="multichannel-images">
                {fixedChannel ?
                  <img
                    src={fixedChannel.downloadURL}
                    alt='fixed channel'
                    className="img-responsive"
                    style={{ opacity: 100 }}
                  />
                  :
                  ''}
                {resources.map((r, index) => (
                  <img
                    key={index}
                    src={r.downloadURL}
                    alt={"Ressource" + index}
                    className="img-responsive"
                    style={{ opacity: votedFor[r.id] / 100 }}
                  />
                ))}
              </div>
            )}
          </div>
        </ReactFullscreen>
      </div>
    );
  }
}

export default ResourceViewer;
